import React, { useState } from 'react';
import './Styles.css';
import { InputField, InputFieldAddon, InputFieldWrapper, InputSize } from '@ids/react-input-field';
import { IconButton, IconButtonSize, IconButtonType, IconButtonVariant } from '@ids/react-icon-button';
import { Ui32ArrowSmDown, Ui32ArrowSmUp } from '@ids/react-icons';
import { useTeamSearch } from './Functions';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import LoaderComponent from '../../../../../Elements/ids/Loader';

const TeamSearch = ({ selectedTeam, setSelectedTeam, existingTeams }) => {
  const [teamSearchState, setTeamSearchState] = useState({
    query: null,
    isLoading: false,
    isOpen: false,
  });

  const teamList = useTeamSearch(
    teamSearchState.query,
    isLoading => {
      setTeamSearchState({ ...teamSearchState, isLoading });
    },
    isOpen => {
      setTeamSearchState({ ...teamSearchState, isOpen });
    },
    selectedTeam?.codePrefix,
    existingTeams
  );

  return (
    <div className="employerPage-connectedTeams-teamSearchContainer">
      <label>{formatMessage(Messages.employerPage_connectedTeams_searchTeamTitle)}</label>
      <InputFieldWrapper
        inputSize={InputSize.SMALL}
        onClick={() => {
          if (!teamSearchState.isOpen) {
            setTeamSearchState({ ...teamSearchState, isOpen: true });
          }
        }}>
        <InputField
          inputSize={InputSize.SMALL}
          onChange={e => {
            setTeamSearchState({ ...teamSearchState, query: e.target.value });
            if (e.target.value.trim().length === 0) {
              setSelectedTeam({ codePrefix: null });
            }
          }}
          value={teamSearchState.query ?? selectedTeam?.codePrefix}
          autoComplete="off"
        />
        <InputFieldAddon>
          <IconButton
            type={IconButtonType.PLAIN}
            variant={IconButtonVariant.QUIET}
            size={IconButtonSize.X_SMALL}
            onClick={() => {
              if (teamSearchState.isOpen) {
                setTeamSearchState({ ...teamSearchState, isOpen: false });
              }
            }}>
            {teamSearchState.isOpen ? <Ui32ArrowSmUp /> : <Ui32ArrowSmDown />}
          </IconButton>
        </InputFieldAddon>
      </InputFieldWrapper>

      {teamSearchState.isLoading ? (
        <LoaderComponent />
      ) : (
        <>
          {teamSearchState.isOpen && (
            <ul className="employerPage-connectedTeams-searchResults">
              {teamList.map(team => (
                <li
                  key={team.codePrefix}
                  className="employerPage-connectedTeams-searchResults-row clickable"
                  onClick={() => {
                    setSelectedTeam({ codePrefix: team.codePrefix });
                    setTeamSearchState({
                      ...teamSearchState,
                      isOpen: false,
                      query: null,
                    });
                  }}>
                  {team.codePrefix}
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};

export default TeamSearch;
